import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { Crumb } from '@shared/components/breadcrumbs/breadcrumbs.component';
import { PlatformService } from '@panamax/app-state';
@Component({
  selector: 'app-manage-alerts-header',
  templateUrl: './manage-alerts-header.component.html',
  styleUrls: ['./manage-alerts-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageAlertsHeaderComponent implements OnInit {
  breadcrumbs: Crumb[];

  constructor(public readonly platformService: PlatformService) {}

  ngOnInit() {
    this.breadcrumbs = [
      { label: 'i18n.breadcrumbs.home', url: '/desktop/home', active: false },
      { label: 'i18n.breadcrumbs.manageAlerts', url: '', active: true },
    ];
  }
}
